import styled from "styled-components";

export const DenialImage = styled.img`
    margin: 15px 0;
    max-height: 250px;
`;